import { DisplaySlotDto } from '../../../api/gen/model/displaySlotDto';
import { DisplaySlotType } from '../../../api/gen/model/displaySlotType';
import { DisplayState } from '../../../api/gen/model/displayState';

/**
 * Starting layout for a reversible lane's closed screens, so a new template does not open on an empty editor.
 * Wording is the customer's own (Albert, 2026-09-03: "Einfahrt gesperrt" / "Ausfahrt gesperrt"); the second
 * line is filled from the `lane.opens_at` live data the backend sends with these states.
 * Returns null for every other state.
 */
export function defaultClosedLaneSlots(state: DisplayState): DisplaySlotDto[] | null {
    const headline = state === DisplayState.EntryClosed
        ? 'Einfahrt gesperrt'
        : state === DisplayState.ExitClosed
            ? 'Ausfahrt gesperrt'
            : null;
    if (!headline) return null;

    return [
        {
            orderNumber: 0,
            slotType: DisplaySlotType.StaticText,
            value: headline,
            heightPercent: 60,
            fontSize: '8vh',
            fontWeight: 'bold',
            fontColor: '#FFFFFF',
            backgroundColor: '#FF5252',
            textAlign: 'center',
            visible: true,
        },
        {
            orderNumber: 1,
            slotType: DisplaySlotType.DynamicText,
            value: 'ab {lane.opens_at}',
            heightPercent: 40,
            fontSize: '6vh',
            fontColor: '#1A2233',
            backgroundColor: '#F6FAFD',
            textAlign: 'center',
            visible: true,
        },
    ];
}
